import { useDesignMaxTheme } from "@/packages";
import { Box, Center, Grid } from "@chakra-ui/react";

export const ImgGallery = ({ imgList }: { imgList?: { img_URL: string }[] }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    const sliceImgLIst = imgList && imgList.slice(0, 6);

    return (
        <Center position="relative" w="100%">
            <Center as="section" p="0 0 120px 0">
                <Grid templateColumns={`repeat(${isMobile ? "1" : "3"},1fr)`} gap="24px" p="0 20PX">
                    {sliceImgLIst ? (
                        sliceImgLIst.map((img) => (
                            <Box
                                key={Math.random()}
                                h={isMobile ? "256px" : "504px"}
                                bg={img ? `url(${img.img_URL})no-repeat center/cover` : "gray.100"}
                            />
                        ))
                    ) : (
                        <>
                            <Box h="504px" bg="gray.100" />
                            <Box h="504px" bg="gray.100" />
                            <Box h="504px" bg="gray.100" />
                            <Box h="504px" bg="gray.100" />
                            <Box h="504px" bg="gray.100" />
                            <Box h="504px" bg="gray.100" />
                        </>
                    )}
                </Grid>
            </Center>
        </Center>
    );
};
